import React, { useState, useEffect } from "react";
import allApi from "../../../api/allApi";

const RoleInfo = ({
  showPopUp,
  handleClose,
  headerMessage1,
  handleSuccess,
}) => {
  const [roles, setRoles] = useState([]);

  useEffect(() => {
    fetchRoles();
  }, []);

  const fetchRoles = async () => {
    try {
      const api = new allApi();
      const response = await api.getRequest(`api/user/findAllRoles`);
      setRoles(response);
    } catch (error) {
      console.error("Error fetching roles:", error);
    }
  };

  return (
    <>
      {showPopUp && (
        <div
          className="modal fade customModal show"
          id="discover"
          style={{
            display: "block",
            zIndex: 1009,
            backgroundColor: "rgba(0, 0, 0, 0.5)",
          }}
        >
          <div className="modal-dialog modal-dialog-centered small-modal">
            <div
              className="modal-content"
              style={{ borderRadius: "10px", padding: "20px" }}
            >
              <div className="modal-header">
                <h5 className="modal-title text-primary">{headerMessage1}</h5>
                <button
                  type="button"
                  className="btn-close"
                  aria-label="Close"
                  data-bs-dismiss="modal"
                  onClick={handleClose}
                ></button>
              </div>
              <div className="modal-body">
                <p className="mb-3" style={{ fontSize: "14px", color: "#444" }}>
                  In this given role list, if you select a position{" "}
                  <strong>Above</strong> another role, it means you are
                  assigning access <strong>to all roles below</strong> that
                  position as well. If you select a position{" "}
                  <strong>Below</strong>, only access related to that specific
                  role will be granted.
                </p>

                <strong>Role List:</strong>
                <ul style={{ paddingLeft: "20px", marginTop: "10px" }}>
                  {roles.map((role, index) => (
                    <li key={index} style={{ fontSize: "14px", color: "#333" }}>
                      {role.name}
                    </li>
                  ))}
                </ul>
              </div>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default RoleInfo;
